import { useEffect } from "react";
import type { Dispatch, SetStateAction } from "react";
import { supabase } from "../lib/supabase";

type BotStatusListenerProps = {
  practitionerId: string | null;
  setBotsOff: Dispatch<SetStateAction<Record<string, boolean>>>;
};

export default function BotStatusListener({
  practitionerId,
  setBotsOff,
}: BotStatusListenerProps) {
  useEffect(() => {
    setBotsOff({});
    if (!practitionerId) return;

    let isActive = true;

    async function loadBotStatuses() {
      const { data } = await supabase
        .from("bot_status")
        .select("utilisateur, status")
        .eq("praticien_id", practitionerId);

      if (!isActive) return;

      const map: Record<string, boolean> = {};
      (data || []).forEach((r) => {
        map[r.utilisateur] = r.status === "off";
      });
      setBotsOff(map);
    }

    void loadBotStatuses();

    // Realtime listener
    const channel = supabase
      .channel(`bot_status_realtime_${practitionerId}`)
      .on(
        "postgres_changes",
        {
          event: "*",
          schema: "public",
          table: "bot_status",
          filter: `praticien_id=eq.${practitionerId}`,
        },
        (payload) => {
          const row = payload.new || payload.old;
          if (!row) return;

          setBotsOff((prev) => ({
            ...prev,
            [row.utilisateur]: row.status === "off",
          }));
        }
      )
      .subscribe((status) => {
        if (status === "SUBSCRIBED") {
          void loadBotStatuses();
        }
      });

    return () => {
      isActive = false;
      supabase.removeChannel(channel);
    };
  }, [practitionerId, setBotsOff]);

  return null;
}
